import { render, staticRenderFns } from "./AgendamentoColaborador.vue?vue&type=template&id=4a7670ad&"
import script from "./AgendamentoColaborador.vue?vue&type=script&lang=js&"
export * from "./AgendamentoColaborador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})
